import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchDeleteBulkGroupFailure,
  fetchDeleteBulkGroupSuccess,
} from "../slices/features/deleteContact";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* bulkDeleteGroupSaga(action: any) {
  const { payload } = action;
  const { id, data, meta } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.bulkDeleteGroup,
      baseUrl,
      id,
      data,
      meta
    );

    yield put(fetchDeleteBulkGroupSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchDeleteBulkGroupFailure({ statusCode, statusText }));
  }
}

export function* watchBulkDeleteGroups() {
  yield takeLatest(RequestTypes.DELETE_BULK_GROUPS, bulkDeleteGroupSaga);
}
